import styled from "styled-components";

export const CrossButton = styled.button`
  color: ${({ theme }) => theme.colorTextSecondary};
  &:hover:enabled {
    color: ${({ theme }) => theme.colorTextMain};
    background-color: transparent;
  }
`;
